import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Alert, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./AddPurchase.css";
import axios from "axios";

const LeavePermissionForm = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [customerList, setCustomers] = useState([]);
  const navigate = useNavigate();
  const [conflictModal, setConflictModal] = useState({ show: false, message: "" });
  const [selectedUser, setSelectedUser] = useState(null);


  const [formData, setFormData] = useState({
    user_id: "0",
    type: "",
    session: "",
    leave_date: "",
    leave_type: "",
    aided_leave_type: "",
    duration: "0", // New duration field
    reason: "",
    work_adjustment_id: "0"
  });

  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "file") {
      // const file = files[0] || null;
      // setFormData((prev) => ({ ...prev, [name]: file }));
      // setAttachmentPreview(file ? URL.createObjectURL(file) : null);
    } else if (type === "checkbox") {
      // setFormData((prev) => ({ ...prev, [name]: checked }));
    } else if (name === "customer_name") {
      // setSearchTerm(value);
      setFormData((prev) => ({
        ...prev,
        user_id: value
      }));

      // const matched = customerList.find(
      //   (c) => c.name.toLowerCase() === value.toLowerCase()
      // );

      // if (matched) {
      //   setFormData((prev) => ({
      //     ...prev,
      //     customer_name: matched.name,
      //     mobile: matched.mobile,
      //     address: matched.address,
      //   }));
      // }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSelectCustomer = (user_id) => {
    const selected = customerList.find((c) => c.user_id === user_id);
    if (selected) {
      setFormData((prev) => ({
        ...prev,
        user_id: selected.user_id
      }));
      // setSearchTerm(selected.name);

      // Save selected user details in state
      setSelectedUser(selected || null);
    }
  };

  const validate = () => {
    const e = {};
    if (!formData.user_id.trim()) e.user_id = "Name is required";
    // if (!formData.mobile || !/^\d{10}$/.test(formData.mobile))
    //   e.mobile = "Enter valid 10-digit mobile";
    if (!formData.type) e.type = "Select type";
    if (!formData.leave_date) e.leave_date = "Select date";
    // Add validation for duration when type is permission
    if (formData.type === "permission" && !formData.duration) {
      e.duration = "Select duration for permission";
    }
    if (!formData.reason.trim()) e.reason = "Reason is required";
    // if (!formData.action_by.trim())
    //   e.action_by = "Action by (approver) is required";
    return e;
  };

  const handleSubmit = (ev) => {
    ev.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length) {
      console.log(validationErrors);
      setErrors(validationErrors);
      setSuccessMsg("");
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    setErrors({});

    // Convert duration to number before submitting
    const payload = {
      ...formData,
      // duration: formData.duration ? Number(formData.duration) : 0, // Convert to number
      // date: formData.date
      //   ? new Date(formData.date).toISOString().split("T")[0]
      //   : "",
      // attachmentName: formData.attachment ? formData.attachment.name : null,
    };

    console.log("Leave/Permission Request Submitted:", payload);
    console.log("Duration type:", typeof payload.duration, "Value:", payload.duration);

    axios.post(`${API_BASE_URL}leave_permission_add.php`, formData)
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          setSuccessMsg("Request submitted successfully");
          navigate("/permissionleavelist")
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          if (response.data.head.msg.includes("Already Another Person Apply Leave for Same Date in Your Department")) {
            showConflictModal(
              `Another person from your department has already requested leave on same date. ` +
              `Only one staff member per department can take leave on the same date. ` +
              `Please choose a different date or coordinate with your team.`
            );
          }
          // setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
    // setTimeout(() => navigate("/permissionleavelist"), 900);
  };

  const renderError = (field) =>
    errors[field] && (
      <div className="text-danger small mt-1">{errors[field]}</div>
    );

  useEffect(() => {
    axios.post(`${API_BASE_URL}user_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);


        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);
  // console.log("----------------",customerList.remaining_leave);
  const showConflictModal = (message) => {
    setConflictModal({ show: true, message });
  };

  return (
    <Container className="my-4">
      <div className="form-header mb-4 d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Request Leave | Permission</h4>
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      {successMsg && <Alert variant="success">{successMsg}</Alert>}

      {/* Department Conflict Modal */}
      <Modal show={conflictModal.show} onHide={() => setConflictModal({ show: false, message: "" })}>
        <Modal.Header closeButton>
          <Modal.Title>Department Leave Conflict</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning">
            {conflictModal.message}
          </Alert>
          <p className="mb-0">
            <strong>Note:</strong> Permission requests are not affected by this rule.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setConflictModal({ show: false, message: "" })}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      <Form onSubmit={handleSubmit} noValidate>
        <Row className="g-3">
          {/* 🔽 Customer Name Dropdown + Search */}
          <Col lg={4} md={4}>
            <Form.Group>
              <Form.Label>User</Form.Label>
              <Form.Select
                name="user_id"
                value={formData.user_id}
                onChange={(e) => handleSelectCustomer(e.target.value)}
                className="custom-select-arrow"
              >
                <option value="">Select User</option>
                {customerList.map((c, idx) => (
                  <option key={idx} value={c.user_id}>
                    {c.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          {/* 🔒 Read-only Mobile */}
          {/* <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Mobile</Form.Label>
              <Form.Control
                type="tel"
                name="mobile"
                value={formData.mobile}
                readOnly
                placeholder="Auto-filled"
              />
              {renderError("mobile")}
            </Form.Group>
          </Col> */}

          <Col lg={4} md={4}>
            <Form.Group>
              <Form.Label>Type</Form.Label>
              <Form.Select
                name="type"
                value={formData.type}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Type</option>
                <option value="Leave">Leave</option>
                <option value="Half Day Leave">Half Day Leave</option>
                <option value="Permission">Permission</option>
              </Form.Select>
              {renderError("type")}
            </Form.Group>
          </Col>

          <Col lg={4} md={4}>
            {formData.type === "Half Day Leave" && (
              <Form.Group className="mt-3">
                <Form.Label>Session</Form.Label>
                <div className="d-flex gap-4">
                  <Form.Check
                    type="radio"
                    label="Forenoon"
                    name="session"
                    value="FN"
                    checked={formData.session === "FN"}
                    onChange={handleChange}
                    className="dark-radio"
                  />

                  <Form.Check
                    type="radio"
                    label="Afternoon"
                    name="session"
                    value="AN"
                    checked={formData.session === "AN"}
                    onChange={handleChange}
                    className="dark-radio"
                  />

                </div>
              </Form.Group>
            )}
          </Col>


          {/* Date and Duration in the same row */}
          <Col lg={3} md={12}>
            <Form.Group>
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                name="leave_date"
                value={formData.leave_date}
                onChange={handleChange}
              />
              {renderError("leave_date")}
            </Form.Group>
          </Col>

          {selectedUser?.staff_type != "Aided" && formData.type != "Permission" && (
            <Col lg={6} md={12}>
              <Form.Group>
                <Form.Label>Leave Type</Form.Label>
                <Form.Control
                  type="text"
                  // name="reason"
                  value="CL"
                  // onChange={handleChange}
                  readOnly
                  placeholder="Brief reason for leave/permission"
                />
                {renderError("reason")}
              </Form.Group>
            </Col>
          )}

          {selectedUser?.staff_type === "Aided" && (
            <Col lg={6} md={12}>
              <Form.Group>
                <Form.Label>Leave Type</Form.Label>
                <Form.Select
                  name="aided_leave_type"
                  value={formData.aided_leave_type}
                  onChange={handleChange}
                  className="custom-select-arrow"
                >
                  <option value="">Select</option>

                  <option
                    value="CL"
                    disabled={selectedUser.remaining_leave <= 0.0}
                    style={{
                      fontWeight: selectedUser.remaining_leave != 0 ? "bold" : "normal"
                    }}
                  >
                    CL {selectedUser.remaining_leave <= 0.0 ? "" : ""}
                  </option>

                  <option
                    value="ML"
                    disabled={selectedUser.remaining_leave_ml <= 0.0}
                    style={{
                      fontWeight: selectedUser.remaining_leave_ml != 0 ? "bold" : "normal"
                    }}
                  >
                    ML {selectedUser.remaining_leave_ml <= 0.0 ? "" : ""}
                  </option>

                  <option
                    value="RL"
                    disabled={selectedUser.remaining_leave_rl <= 0.0}
                    style={{
                      fontWeight: selectedUser.remaining_leave_rl != 0 ? "bold" : "normal"
                    }}
                  >
                    RL {selectedUser.remaining_leave_rl <= 0.0 ? "" : ""}
                  </option>

                  <option
                    value="EL"
                    disabled={selectedUser.remaining_leave_el <= 0.0}
                    style={{
                      fontWeight: selectedUser.remaining_leave_el != 0 ? "bold" : "normal"
                    }}
                  >
                    EL {selectedUser.remaining_leave_el <= 0.0 ? "" : ""}
                  </option>

                  <option
                    value="UEL"
                    disabled={selectedUser.remaining_leave_uel <= 0.0}
                    style={{
                      fontWeight: selectedUser.remaining_leave_uel != 0 ? "bold" : "normal"
                    }}
                  >
                    UEL {selectedUser.remaining_leave_uel <= 0.0 ? "" : ""}
                  </option>
                  {selectedUser.gender === "Female" && (

                    <option
                      value={selectedUser.gender !== "Female" ? "" : "Maternity Leave"}
                      disabled={
                        selectedUser.maternity_leave <= 0.0 ||
                        selectedUser.gender !== "Female"
                      }
                      style={{
                        fontWeight: selectedUser.maternity_leave > 0 ? "bold" : "normal"
                      }}
                    >
                      {selectedUser.gender !== "Female" ? "" : "Maternity Leave"}
                      {(selectedUser.maternity_leave <= 0.0 ||
                        selectedUser.gender !== "Female")
                        ? ""
                        : ""}
                    </option>
                  )}
                </Form.Select>
                {renderError("aided_leave_type")}
              </Form.Group>
            </Col>
          )}

          {/* New Duration Field - Show for both types but only required for permission */}
          <Col lg={3} md={12}>
            <Form.Group>
              <Form.Label>Permission (Hours)</Form.Label>
              <Form.Select
                name="duration"
                value={formData.duration ?? "0"}
                onChange={handleChange}
                className="custom-select-arrow"
                required={formData.type === "permission"}
              >
                <option value="0">Select Hours</option>
                {[1, 2, 3, 4, 5].map((hour) => (
                  <option key={hour} value={hour}>
                    {hour} {hour === 1 ? "hour" : "hours"}
                  </option>
                ))}
              </Form.Select>
              {renderError("duration")}
            </Form.Group>
          </Col>

          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Reason</Form.Label>
              <Form.Control
                type="text"
                name="reason"
                value={formData.reason}
                onChange={handleChange}
                placeholder="Brief reason for leave/permission"
              />
              {renderError("reason")}
            </Form.Group>
          </Col>

          {/* Updated Work Adjustment - Now a dropdown */}
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Work Adjustment</Form.Label>
              <Form.Select
                name="work_adjustment_id"
                value={formData.work_adjustment_id}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select who will handle your work</option>
                {customerList.map((user, idx) => (
                  <option key={idx} value={user.user_id}>
                    {user.name}
                  </option>
                ))}
              </Form.Select>
              <Form.Text className="text-muted">
                Select the colleague who will handle your work during your absence
              </Form.Text>
            </Form.Group>
          </Col>
          {/* 
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Attachment<span className="text-muted small">(MC)</span></Form.Label>
              <Form.Control
                type="file"
                name="attachment"
                onChange={handleChange}
                accept="image/*,application/pdf"
              />
              {formData.attachment && (
                <div className="mt-2 small text-muted">
                  Selected: {formData.attachment.name}
                </div>
              )}
            </Form.Group>
          </Col> */}

          {/* 🔒 Read-only Address */}
          {/* <Col lg={6}>
            <Form.Group>
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name="address"
                value={formData.address}
                readOnly
                placeholder="Auto-filled address"
              />
            </Form.Group>
          </Col> */}
        </Row>

        <div className="form-actions mt-4 d-flex justify-content-end gap-2">
          <Button type="submit" className="btn-submit">
            Submit
          </Button>
          <Button className="btn-top" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default LeavePermissionForm;